module.exports = __webpack_public_path__ + "img/DailyCharge.c7bf6015.png";